import { AppRegistry } from "react-native"
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import FeatherFont from "components/node_modules/@react-native-vector-icons/feather/fonts/Feather.ttf";  // https://github.com/oblador/react-native-vector-icons/blob/61827c4afbd06a27e694e5b2c5c38ab9c56dfd29/docs/SETUP-WEB.md
import monaco from "components/assets/fonts/Monaco.ttf";
import "./index.css";

// Generate required css
const iconFontStyles = [];
iconFontStyles.push(`@font-face {
  src: url(${FeatherFont});
  font-family: Feather;
}`);
iconFontStyles.push(`@font-face {
  src: url(${monaco});
  font-family: Monaco;
}`);
// Create stylesheet
const style = document.createElement("style");
style.type = "text/css";
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles.join("\n");
} else {
  style.appendChild(document.createTextNode(iconFontStyles.join("\n")));
}
// Inject stylesheet
document.head.appendChild(style);

AppRegistry.registerComponent("App", () => App);
AppRegistry.runApplication("App", {
  initialProps: {},
  rootTag: document.getElementById(("root")),
});

// ORIGINAL:
// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// serviceWorker.unregister();
